;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.product', [
      'kilo.routes.product.show',
      'kilo.routes.product.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {

    var parentState = {
      name: 'product',
      url: '/product',
      abstract: true
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
